export const SITE_URL = "https://bima-quote.emergent.host";

export const PHONE = "9598063001";
export const PHONE_DISPLAY = "+91 95980 63001";
export const PHONE_TEL = "tel:+919598063001";
export const EMAIL = "pocketbimaofficial@gmail.com";
export const EMAIL_MAILTO = "mailto:pocketbimaofficial@gmail.com";
export const ADDRESS = "N-303, Stellar Jeevan, GH-03, Sector 1, Greater Noida West, U.P. - 201318";
export const ORAI_BRANCH = {
  name: "Orai Branch",
  address: "Near Hotel Anandi Inn, Diggital, Patel Nagar, Orai, Uttar Pradesh 285001",
};
export const WHATSAPP_URL =
  "https://wa.me/919598063001?text=" +
  encodeURIComponent("Hello PocketBima, I would like to know more about insurance plans.");
export const MAPS_EMBED =
  "https://www.google.com/maps?q=" + encodeURIComponent(ADDRESS) + "&output=embed";

export const SOCIALS = [
  { label: "Facebook", href: "https://www.facebook.com/pocketbima" },
  { label: "Instagram", href: "https://www.instagram.com/pocketbima.official" },
  { label: "X", href: "https://x.com/pocketbima" },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/pocketbima/" },
];

export const INSURANCE_TYPES = [
  "Car Insurance",
  "Bike Insurance",
  "Taxi Insurance",
  "GCV Insurance",
  "Health Insurance",
  "Life Insurance",
  "Term Insurance",
  "Group Health Insurance",
  "Group Personal Accident Insurance",
  "Group Term Insurance",
  "Fire Insurance",
  "Third Party Insurance",
  "Workmen Compensation Insurance",
  "Marine Insurance",
  "Single Transit Insurance",
  "Travel Insurance",
];

export const INSURANCE_MENU = [
  { label: "Motor Insurance", to: "/motor-insurance" },
  { label: "Health Insurance", to: "/health-insurance" },
  { label: "Life & Term Insurance", to: "/life-insurance" },
  { label: "Business Insurance", to: "/business-insurance" },
  { label: "Travel Insurance", to: "/travel-insurance" },
];
